export default __webpack_public_path__ + "static/media/4Agendas.126864e2.svg";